import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Col, Row } from "reactstrap";

class SetupBreadcrumbs extends Component {
  render() {
    return (
      <React.Fragment>
        
            <div className="page-title-box border-right-side align-items-center">
              <h5 className="mb-0 font-size-18">Setup</h5>
              <div className="bdLeft">
              <Link to="#">{this.props.title}</Link> /  <Link to="#">{this.props.breadcrumbItem}</Link>
              </div>
              
            </div>
          
      </React.Fragment>
    )
  }
}

SetupBreadcrumbs.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string
}

export default SetupBreadcrumbs
